import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../styles/fonts';
import { mediaQuery } from '../../../styles/helpers';
import { Breakpoint } from '../../../styles/enums';

import { VideoToolHeaderProps } from './types';

const useStyles = createUseStyles<string, Pick<VideoToolHeaderProps, 'centeredLogo'>>(
  {
    root: {
      display: 'flex',
      gridArea: 'header',
      width: '100%',
      backgroundColor: ({ centeredLogo }) => (centeredLogo ? 'transparent' : 'var(--x-bg-1)'),
      borderBottom: ({ centeredLogo }) =>
        centeredLogo ? '1px solid transparent' : '1px solid var(--x-border-2)',
      justifyContent: ({ centeredLogo }) => (centeredLogo ? 'center' : 'flex-start'),

      [mediaQuery(Breakpoint.Large)]: {
        justifyContent: 'center',
      },
    },
    favicon: {
      display: 'inline-block',
      verticalAlign: 'top',
      width: 32,
      height: 32,
      marginRight: 8,
    },
    content: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      padding: ({ centeredLogo }) => (centeredLogo ? '40px 14px 32px' : '14px 40px'),
    },
    logoLink: {
      display: 'inline-block',
      height: 32,
      fontSize: 20,
      lineHeight: '28px',
      color: 'var(--x-accent-1-1)',
      fontWeight: FontWeight.Bold,
      padding: '3px 0',
    },
    title: {
      display: 'inline-block',
      marginInlineStart: 8,
      fontWeight: FontWeight.Medium,
      fontSize: 20,
      color: 'var(--x-text-color-1)',
      lineHeight: '28px',
    },
  },
  {
    name: 'header',
  },
);

export default useStyles;
